import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import { Provider as ReduxProvider } from "react-redux";
import store from "./store";
import { SnackbarProvider } from "notistack";
import setup from "./utils/authInterceptor";
import ErrorBoundary from "./components/ErrorBoundary/ErrorBoundary";

setup();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <ReduxProvider store={store}>
        <SnackbarProvider autoHideDuration={3000}>
          <App />
        </SnackbarProvider>
      </ReduxProvider>
    </ErrorBoundary>
  </React.StrictMode>,
);

serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
